"use client"
import SPortrait, { SPlaceHolderPersonIconSvg, SUserImage } from 'src/components/filmwebid/ProfileImageStyles';
import { useUserContext } from 'src/lib/contexts/UserContext';
import { envConfig } from 'src/lib/client/envConfig';
import { useMemo, useState } from 'react';

//#region [Styles]

//#endregion

//#region [Props]
type MyProfileImageProps = {
	className?: string
};
//#endregion

//#region [Component]
export default function MyProfileImage({ className }: MyProfileImageProps) {
	const userContext = useUserContext();
	const [isErrorProfilePic, setIsErrorProfilePic] = useState(false);

	const picUrl = useMemo(() => {
		if (userContext.tmpUserImage) {
			return userContext.tmpUserImage;
		}
		if (userContext.userProfile?.hasUploadedPicture) {
			return `${envConfig.NEXT_PUBLIC_FILMWEBIDAPI_BASE}/api/Picture?userId=${userContext.userProfile?.userId}`;
		}

		return userContext.userProfile?.picture ?? null;

	}, [userContext.userProfile?.hasUploadedPicture, userContext.userProfile?.userId, userContext.userProfile?.picture, userContext.tmpUserImage]);

	return (
		<SPortrait $noProfilePic={!userContext.userProfile?.userId || isErrorProfilePic} className={className}>
			{(!picUrl || isErrorProfilePic) && <SPlaceHolderPersonIconSvg />}
			{(picUrl && !isErrorProfilePic) && <SUserImage unoptimized src={picUrl} alt={userContext.userProfile?.userName || "Filmweb bruker"} fill onError={() => setIsErrorProfilePic(true)} />}
		</SPortrait>
	);
}
//#endregion